import { render } from "./NotAttendedModal.vue?vue&type=template&id=73248de0"
import script from "./NotAttendedModal.vue?vue&type=script&lang=js"
export * from "./NotAttendedModal.vue?vue&type=script&lang=js"

import "./NotAttendedModal.vue?vue&type=style&index=0&id=73248de0&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__